<template>
    <div class="page">
        
        <!-- 产品 -->
        <div v-if="isDataLoaded">
            <div class="tabbody">
                <div class="hoome-goods" v-if="!isEmpty(list)">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <GoodsList :list="list" :type="2"></GoodsList>
                    </van-list>
                </div>
                <van-empty v-else description="暂时识别不出来结果，请重新试试" />
            </div>
        </div>

    </div>
</template>

<script>


import mix1 from '@/mixins/page'
import minList from '@/mixins/list'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { localStorageGet, localStorageSet, localStorageRemove } from '@/utils/storage'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Field, Empty, List, Toast } from 'vant'
import MgPopup from '@/components/common/mg-popup'
import TabsBox from '@/components/common/tabs'
import Search from "./components/search.vue";
import GoodsList from './components/list.vue'


export default {
    mixins: [mix1, minList],
    components: {
        Search,
        GoodsList,
        MgPopup, TabsBox, Button, NumberKeyboard,
        [Field.name]: Field,
        [Button.name]: Button,
        [Empty.name]: Empty,
        [List.name]: List,
        
    },
    data() {
        return {
            isDataLoaded: false,
            serchData: {
                imgid: "",
            },
        }
    },
    methods: {
        onLoad() {
            // 下拉
            // 加载状态开始
            this.loading = true;
            this.pagination.page += 1
            
            this.getList()
        },
    
        async getList(type) {
            if(type){
                this.loading = true;
                this.finished = false;
                this.pagination.page = 1
                this.list = []
            }
            uiShowLoading()
            await delayAsync(500)

            const promise = this.apiPost('goods.image', {
                ...this.serchData,
                ...this.pagination
            })

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            this.isDataLoaded = true
            
            // 加载状态结束
            this.loading = false;

            this.list = [...this.list, ...apiResult.list]

            // 数据全部加载完成
            if (this.list.length >= apiResult.pagination.recordTotal) {
                this.finished = true;
            }
        },

    },
    mounted() {

    },
    created() {
        let query = this.$route.query
        this.serchData.imgid = query.id

        // let base64 = localStorageGet('base64')
        // this.serchData.img = base64 || ''
        
        // localStorageRemove('base64')
        this.getList(true)
    }
}
</script>

<style lang="less" scoped>

.van-empty__image {
    width: 500px;
    height: 500px;
}
.page {
}
</style>